import { render, staticRenderFns } from "./dataPushDetails.vue?vue&type=template&id=3f71ef79&scoped=true&"
import script from "./dataPushDetails.vue?vue&type=script&lang=js&"
export * from "./dataPushDetails.vue?vue&type=script&lang=js&"
import style0 from "./dataPushDetails.vue?vue&type=style&index=0&id=3f71ef79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71ef79",
  null
  
)

export default component.exports